module.exports = __webpack_public_path__ + "img/BQLogo.36cd2fbf.png";